// extracted by mini-css-extract-plugin
export default {"RightInfoTitle":"MonthIncComingRank_RightInfoTitle__zZaE1","relatedPartyMaint":"MonthIncComingRank_relatedPartyMaint__bG1xm"};